<template>
  <div class="wrap">
    <div
      class="head-img"
      v-show="showFilter&&currentFilterValue !== '法律'&&'法规'"
    >
      <div class="head-wrap">
        <div class="filter-list">
          <filterList :listData="listData" :currentValue="currentFilterValue" @changeFilter='changeFilter'/>
        </div>
        <search-list ref="searchList" />
      </div>
    </div>
    <div class="multuple-wrap" v-if="showFilter||currentFilterValue === '法律'||'法规'">
      <multipleFilter ref="multupleRef"  :multipleData="multipleData" />
    </div>
    <div class="content">
      <normal-list :currentFilterValue="currentFilterValue" />
      <pagination v-if="page.totalPage>1" :page="page" @on-change="changePage"></pagination>
    </div>
  </div>
</template>

<script>
import normalList from '@/components/normalList';
import filterList from '@/components/filterList';
import searchList from '@/components/searchList';
import multipleFilter from '@/components/multipleFilter';
import standard from './config/standard';
import metroloy from './config/metroloy';
import test from './config/test';
import certification from './config/certification';
import law from './config/law';
import news from './config/news';
import Pagination from '@/components/pagination'
export default {
  components: {
    normalList,
    searchList,
    filterList,
    multipleFilter,
    Pagination
  },
  data () {
    return {
      listParams: {},
      // page: {
      //   currPage: 1,
      //   // totalPage: 10,
      //   pageSize: 10
      // },
      showMul: false,
      listData: [
        {
          id: '1',
          name: '计量'
        },
        {
          id: '2',
          name: '标准'
        },
        {
          id: '3',
          name: '认证认可'
        },
        {
          id: '4',
          name: '检验检测'
        }
      ],
      multipleData: {}
    };
  },
  created () {
    this.changeTopSelect();
  },
  mounted () {
    if (this.$store.state.isHot) {
      this.getHotData()
    } else {
      if ((this.showFilter && !this.$store.state.isTopNav) || this.$store.state.isSliderNav) {
        this.$refs.searchList.changeValue(this.page, 'fromPage');
      }
    }
  },
  computed: {
    currentFilterValue: function () {
      return this.$store.state.currentFilterValue;
    },
    showFilter () {
      return this.currentFilterValue === '计量' || this.currentFilterValue === '标准' || this.currentFilterValue === '认证认可' || this.currentFilterValue === '检验检测'
    },
    page () {
      return this.$store.state.normalListDataPage
    },
    multipleValue () {
      return this.$store.state.multipleValue
    }
  },
  watch: {
    currentFilterValue () {
      this.$store.commit('saveNormalListData', []);
      this.changeTopSelect();
    },
    multipleValue () {
      this.$refs.multupleRef.chooseHeadInit(this.$store.state.multipleValue ? this.$store.state.multipleValue : this.headData[0])
    },
    $route () {
      // 跳转到该页面后需要进行的操作
      if (this.$store.state.isHot) {
        this.getHotData()
      } else {
        if ((this.showFilter && !this.$store.state.isTopNav) || this.$store.state.isSliderNav) {
          this.$refs.searchList.changeValue(this.page, 'fromPage');
        }
      }
    }
  },
  methods: {
    changeFilter () {
      this.$refs.searchList.changeValue(this.page, 'fromPage');
    },
    changePage (page) {
      this.page.currPage = page;
      if (this.$store.state.isHot) {
        this.getHotData()
      } else {
        if ((this.showFilter) || this.$store.state.isSliderNav) {
          this.$refs.searchList.changeValue(this.page, 'fromPage');
        }
      }
      // this.getAccountList();
    },
    getHotData () {
      if (this.$store.state.currentFilterValue === '新闻动态') {
        this.hotDataUrl = '/sys/sysNotice/list'
        // xw
      }
      if (this.$store.state.currentFilterValue === '法规') {
        this.hotDataUrl = '/law/lawAdminRegular/list';
        // xz
      }
      if (this.$store.state.currentFilterValue === '部门规章') {
        this.hotDataUrl = '/law/lawDepartRule/list';
        // bm
      }
      if (this.$store.state.currentFilterValue === '行业规范') {
        this.hotDataUrl = '/law/lawIndustryStandard/list';
        // xy
      }
      if (this.$store.state.currentFilterValue === '法律') {
        this.hotDataUrl = '/law/lawLegal/list';
        // fl
      }
      if (this.$store.state.currentFilterValue === 'CNAS机构') {
        this.hotDataUrl = '/cer/cnas/list';
        // fl
      }
      if (this.$store.state.currentFilterValue === 'CMA机构') {
        this.hotDataUrl = '/cer/cma/list';
        // fl
      }
      if (this.$store.state.currentFilterValue === '数据分析') {
        this.hotDataUrl = 'no api';
        // fl
      }
      // this.$store.commit('saveHotListData', []);
      // this.$store.commit('saveVisible', true)
      if (this.$store.state.activeShow === '法规') {
        this.hotDataUrl = '/law/lawAdminRegular/list';
      }
      if (this.$store.state.activeShow === '政务') {
        this.listParams.fistThemeName = '政务'
      }
      if (this.$store.state.activeShow === '要闻') {
        this.listParams.fistThemeName = '要闻'
      }
      this.verify(
        'post',
        this.hotDataUrl,
        {
          query: this.listParams ? this.listParams : {},
          page: this.page
        },
        res => {
          if (this.$store.state.currentFilterValue === '法规' ||
           this.$store.state.currentFilterValue === '法规' ||
             this.$store.state.currentFilterValue === '政务' ||
              this.$store.state.currentFilterValue === '要闻'
          ) {
            this.$store.commit('saveNormalListData', res.data.list);
            this.$store.commit('saveNormalListDataPage', res.data.page);
          }
          this.$store.commit('saveHotListData', res.data.list);
          this.$store.commit('saveNormalListDataPage', res.data.page);
        }
      );
    },
    changeTopSelect () {
      if (this.$store.state.currentFilterValue === '计量') {
        this.multipleData = metroloy;
      }
      if (this.$store.state.currentFilterValue === '标准') {
        this.multipleData = standard;
      }
      if (this.$store.state.currentFilterValue === '法律' || this.$store.state.currentFilterValue === '法规') {
        this.multipleData = law;
      }
      if (this.$store.state.currentFilterValue === '新闻动态') {
        this.multipleData = news;
      }
      if (this.$store.state.currentFilterValue === '认证认可') {
        this.multipleData = certification;
      }
      if (this.$store.state.currentFilterValue === '检验检测') {
        this.multipleData = test;
      }
      this.$store.commit('saveMultipleData', this.multipleData);
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  margin: 0 auto;
  .head-img {
    height: 176px;
    background-image: url("../../assets/images/beijing.png");
    position: relative;
    .head-wrap {
      width: @body-width;
      height: 96px;
      position: absolute;
      z-index: 1;
      bottom: 0;
      margin: 0 auto;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 1);
      .filter-list {
        width: 200px;
      }
    }
  }
  .multuple-wrap {
    padding: 26px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/common/commonList.vue